import { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { CircularProgress, Box } from '@mui/material'
import 'leaflet/dist/leaflet.css'
import './index.css'
import './i18n/config'
import App from './App.tsx'
import { loadFirebaseConfig } from './services/firebase'

// Load the runtime Firebase config (public/firebase-config.json) before rendering so the
// isFirebaseConfigured / isFirebaseChatEnabled flags are correct on first render (they gate
// chat transport). Fail-soft inside loadFirebaseConfig → SignalR fallback when absent.
async function bootstrap() {
  await loadFirebaseConfig()

  createRoot(document.getElementById('root')!).render(
    // StrictMode disabled due to conflicts with Leaflet map initialization
    // StrictMode causes double-mounting in development which breaks Leaflet
    <Suspense
      fallback={
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <CircularProgress />
        </Box>
      }
    >
      <App />
    </Suspense>,
  )
}

void bootstrap()
